import { store } from "../../redux";
import {addErrorSnack} from "../../../newDomain/barsEnvironment/snack/store/slice";

export const snackError = (message: string | { message: string, invalidToken?: boolean }) => store.dispatch(addErrorSnack(message));
